import React from 'react';
import { connect } from 'react-redux';
import { compose } from '../actions';
import { loadAllDiscoverElements, toggleCategoryFilterName } from '../actions/discover.actions';
import { DiscoverList } from '../components/Discover/DiscoverList';
import { CategoryFilter } from '../components/Discover/CategoryFilter';
import { LoadingSpinner } from '../components/LoadingSpinner/LoadingSpinner.component';
import SectionTitle from '../components/SectionTitle';

import './stylings/Discover.css';

export class Discover extends React.Component {
	componentDidMount() {
		if (this.props.dataIsLoading) {
			this.props.loadAllDiscoverElements();
		}
	}

	handleFilter = (filterName) => {
		this.props.toggleCategoryFilterName(this.props.discoverFilters, filterName, this.props.discoverData);
	}

	render() {
		if (this.props.dataIsLoading) {
			return (<LoadingSpinner />);
		}

		return (
			<section className="discover__section animated fadeIn">
				<div className="container">
					<SectionTitle title="Entdecken" />
					<CategoryFilter filters={this.props.discoverFilters} filterDiscoverElementsHandler={this.handleFilter}/>
					<DiscoverList discoverData={this.props.discoverData} selectArticleAction={this.props.selectDiscoverArticle}/>
				</div>
			</section>
		);
	}
}


const mapStateToProps = ({discover}) => {
	return {
		discoverData: discover.get('discoverData'),
		dataIsLoading: discover.get('dataIsLoading'),
		discoverFilters: discover.get('discoverFilters')
	};
};

const mapDispatchToProps = dispatch => ({
	loadAllDiscoverElements: compose(dispatch, loadAllDiscoverElements),
	toggleCategoryFilterName: compose(dispatch, toggleCategoryFilterName)
});

export default connect(mapStateToProps, mapDispatchToProps)(Discover);


// WEBPACK FOOTER //
// ./src/containers/Discover.js